// Module
var code = `<template class="currency-lookup">
  <require from="./currency-lookup.scss"></require>
  <mdc-text-field ref="input" label.bind="label" readonly.bind="readonly" disabled.bind="disabled">
    <div mdc-text-field-icon trailing if.bind="infoTitle || allowClear">
      <mdc-icon if.bind="infoTitle" mdc-text-field-icon trailing title.bind="infoTitle">info_outline</mdc-icon>
      <button mdc-icon-button click.trigger="clear() & stopPropagation" if.bind="allowClear" icon="clear" mdc-tooltip="Clear selected currency" tabindex="-1"></button>
    </div>
  </mdc-text-field>
  <mdc-text-field-helper-line></mdc-text-field-helper-line>
  <mdc-lookup options.bind="optionsFunction" view-model.ref="lookup" display-field="name" value-field="name" select-on-blur select-on-tab debounce="0" value.bind="value" input.bind="input" preload-options natural-width hoist-to-body perfect-scrollbar>
  </mdc-lookup>
</template>
`;
// Exports
export default code;